// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"3d1ecca8","383":"7148119c"}[chunkId] + ".chunk.js";
};